// extracted by mini-css-extract-plugin
export var modal = "_4w-0";